
// region JS Imports

// region External Modules
// endregion External Modules

// Private Modules
import ImageLazyLoading from "widgets/image_lazyloading"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports

function init() {
  ImageLazyLoading.default_lazyload_instance().update()
}

export default {
  init,
}
